export default __webpack_public_path__ + "6214ae0b42d798a0c9a51503a27a66bf.svg";